import React, { PropsWithChildren } from 'react'
import { Box } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import Link from 'next/link'

import { Item } from 'appTypes/mapper'
import { RelatedProjectIdeas } from 'components/partials/shared'
import { ProductCard } from 'components/ui/Card/ProductCard'
import { Container } from 'styles/shared'
import { normalizeUrl } from 'utils/normalizeUrl'

type Props = {
  itemsCountBreak: number
  products: Item[] | null
  articles: Article[] | null
}

export const BrowseItemsWithAdditionalElements: React.FC<PropsWithChildren<Props>> = ({
  itemsCountBreak,
  children,
  products,
  articles,
}) => {
  return (
    <>
      <Container>
        <Box
          marginTop="44px"
          marginBottom="64px"
          display="grid"
          gridTemplateColumns={{
            base: 'repeat(2, 1fr)',
            lg: 'repeat(4, 1fr)',
          }}
          gridGap="20px"
        >
          {products?.slice(0, itemsCountBreak).map((product, index) => (
            <Link key={index} href="/products/[name]" as={`/products/${normalizeUrl(product.name, product.id)}`}>
              <ProductCard shouldDisplayAvailableInfo={false} key={index} product={product} />
            </Link>
          ))}
        </Box>
      </Container>

      {children}

      <Container>
        <Box
          marginTop="44px"
          marginBottom="64px"
          display="grid"
          gridTemplateColumns={{
            base: 'repeat(2, 1fr)',
            lg: 'repeat(4, 1fr)',
          }}
          gridGap="20px"
        >
          {products?.slice(itemsCountBreak, itemsCountBreak * 2).map((product, index) => (
            <Link key={index} href={`/products/[name]`} as={`/products/${normalizeUrl(product.name, product.id)}`}>
              <ProductCard key={index} product={product} />
            </Link>
          ))}
        </Box>
      </Container>

      {articles && <RelatedProjectIdeas articles={articles} />}

      {products && products.length >= itemsCountBreak * 2 && (
        <Container>
          <Box
            marginTop="44px"
            marginBottom="64px"
            display="grid"
            gridTemplateColumns={{
              base: 'repeat(2, 1fr)',
              lg: 'repeat(4, 1fr)',
            }}
            gridGap="20px"
          >
            {products?.slice(itemsCountBreak * 2, products.length).map((product, index) => (
              <Link key={index} href={`/products/[name]`} as={`/products/${normalizeUrl(product.name, product.id)}`}>
                <ProductCard key={index} product={product} />
              </Link>
            ))}
          </Box>
        </Container>
      )}
    </>
  )
}
